// This file was generated automatically as a part of the SourceWhale ES6 refactor 🐳.
import { initializeGeneralUtils } from "../src/general/utils";
import { initializeAttachments } from "../src/sidebar/campaigns/attachments";
import { initializeSidebar } from "../../../svelte/src/bindings/sidebar.js";
import { bindSystemBannerNotifications } from "../../../svelte/src/bindings/system-banner-notifications.js";
import { bindTestPanel } from "../../../svelte/src/bindings/test-panel-prod.js";
import { bindTodosModal } from "../../../svelte/src/bindings/todos-modal.js";
import { initializeProfile } from "../src/dropdown/profile.js";
import { initializeConfig } from "../src/general/config.js";
import { initializeTinymce } from "../src/general/elements/tinymce.js";
import { initializeTheme } from "../src/general/theme.js";
import { initializeTracking } from "../src/general/tracking.js";
import { initializeVisibilities } from "../src/general/visibilities.js";
import { initializeMarketingModal } from "../src/marketing/marketing.js";
import { initializeUploads } from "../src/uploads/uploads.js";
import { initializeWins } from "../src/wins/wins.js";

bindTestPanel();
bindSystemBannerNotifications();
bindTodosModal();
initializeTheme();
initializeConfig();
initializeGeneralUtils();
initializeTinymce();
initializeAttachments();
initializeSidebar();
initializeTracking();
initializeWins();
initializeUploads();
initializeMarketingModal();
initializeProfile();
initializeVisibilities();
